// SYMIN KPI metric card - high-density, semantic-accent, mono numerics.
export function KpiMetricCard({ title, value, unit, sub, accent = "#C20511", testid }) {
  return (
    <div data-testid={testid}
      className="relative p-4 rounded-lg bg-card border border-border hover:border-[#273D5E] transition-colors flex flex-col justify-between min-h-[112px]">
      <div className="flex items-center justify-between">
        <span className="text-[10px] font-mono uppercase tracking-[0.18em] text-muted-foreground">{title}</span>
        <span className="h-2 w-2 rounded-full shrink-0" style={{ backgroundColor: accent }} />
      </div>
      <div className="mt-3 flex items-baseline gap-1.5">
        <span className="text-[28px] leading-none font-mono font-semibold" style={{ color: accent }} data-testid={testid ? `${testid}-value` : undefined}>{value}</span>
        {unit && <span className="text-xs font-mono text-muted-foreground">{unit}</span>}
      </div>
      {sub && <div className="mt-3 pt-2 border-t border-border/60 text-[11px] text-muted-foreground">{sub}</div>}
    </div>
  );
}
